import { DebtOffering } from 'types/debt-offerings';
import { investmentEntityRequest } from '@utils/request';
import moment from 'moment';

export async function getActiveDebtOfferings(): Promise<Array<DebtOffering>> {
	const response = await investmentEntityRequest.get(`/debt-offerings`);
	response.data.forEach((debtOffering: DebtOffering) => {
		debtOffering.maturityDate = moment(debtOffering.maturityDate).format('MMM D, YYYY');
		debtOffering.achTransactionDate = moment(debtOffering.achTransactionDate).format('MMM D, YYYY');
	});
	return response.data;
}
